/*!
 *   Copyright 2022-2023  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

@import "../../../scss/vars";
@import "../../../scss/gts";

:host {

  .heading {

  }

  table {
    width: 100%;
    color: var(--warp-view-font-color, $w10-charcoal);
    table-layout: auto;

    input[type=text].discovery-input {
      display: inline-block;
      font-size: var(--warp-view-input-font-size, 1rem);
      border-radius: var(--warp-view-input-border-radius, 0.25rem);
      border: 1px solid var(--warp-view-input-border-color, $w10-lightgrey);
      color: var(--warp-view-input-label-color, $w10-charcoal);
      background-color: var(--warp-view-input-bg-color, $w10-white);
      vertical-align: middle;
      width: calc(100% - var(--warp-view-datagrid-cell-padding, 5px));
      height: 34px;
      padding: 1px 5px;
      margin-left: calc(var(--warp-view-datagrid-cell-padding, 5px) * -1);
    }

    th {
      &.pointer {
        cursor: pointer;
      }

      &.sortable {
        &.asc::after {
          content: '▲';
          margin-right: 3px;
        }

        &.desc::after {
          margin-right: 3px;
          content: '▼';
        }
      }
    }

    td, th {
      padding: var(--warp-view-datagrid-cell-padding, 5px);
      white-space: nowrap;
      font-size: var(--warp-view-font-size, 1rem);
    }

    th:last-child {
      width: 100% !important;
    }

    .odd {
      background-color: var(--warp-view-datagrid-odd-bg-color, $w10-white);
      color: var(--warp-view-datagrid-odd-color, $w10-charcoal);
    }

    .even {
      background-color: var(--warp-view-datagrid-even-bg-color, $w10-lightgrey);
      color: var(--warp-view-datagrid-even-color, $w10-black);
    }
  }

  .center {
    text-align: center;

    .pagination {
      display: inline-block;

      .index, .next, .prev {
        color: var(--warp-view-font-color, $w10-charcoal);
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
        border: 1px solid var(--warp-view-pagination-border-color, $w10-lightgrey);
        margin: 0;
        cursor: pointer;
        background-color: var(--warp-view-pagination-bg-color, $w10-white);

        &.active {
          background-color: var(--warp-view-pagination-active-bg-color, #4CAF50);
          color: var(--warp-view-pagination-active-color, $w10-white);
          border: 1px solid var(--warp-view-pagination-active-border-color, #4CAF50);
        }

        &.hoverable:hover {
          background-color: var(--warp-view-pagination-hover-bg-color, $w10-lightgrey);
          color: var(--warp-view-pagination-hover-color, $w10-black);
          border: 1px solid var(--warp-view-pagination-hover-border-color, $w10-lightgrey);
        }

        &.disabled {
          cursor: auto;
          color: var(--warp-view-pagination-disabled-color, $w10-lightgrey);
        }
      }
    }
  }

  .round {
    border-radius: 50%;
    background-color: #bbbbbb;
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 2px solid #454545;
  }

  ul {
    list-style: none;
  }

  .stickyHeader {
    position: sticky;
    top: -10px;
    background-color: var(--warp-view-bg-color, $w10-white);
  }

  .nospace {
    border-spacing: 0;
  }
}
